import Vue from 'vue'
import Router from 'vue-router'
import CreditCard from './views/CreditCard.vue'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: __dirname,
  routes: [{
    path: '/:customer_id',
    name: 'credit-card-route',
    component: CreditCard
  }, ]
})